module.exports = "/images/gotlands_elforsaljning_ab.png?290bcd0bee95604ae0f5984265909f6e";